module.exports = __webpack_public_path__ + "img/76_28.75f0105d.png";